/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_HintInputs */

const en_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefer email? Use the form below and we will reply to the address you provide.`)
};

const es_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Prefieres el correo? Usa el formulario y responderemos a la dirección que indiques.`)
};

const de_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorzugen Sie E-Mail? Nutzen Sie das untenstehende Formular und wir antworten Ihnen an die von Ihnen angegebene Adresse.`)
};

const zh_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更喜欢电子邮件？使用下面的表格，我们将回复你提供的地址。`)
};

const ar_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفضّل البريد؟ استخدم النموذج أدناه وسنردّ على العنوان الذي تقدّمه.`)
};

const fr_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous préférez le courrier électronique ? Utilisez le formulaire ci-dessous et nous vous répondrons à l'adresse que vous fournissez.`)
};

const vi_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thích dùng email? Điền form bên dưới và chúng tôi sẽ trả lời địa chỉ bạn cung cấp.`)
};

const sw_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je, unapendelea barua pepe? Tumia fomu iliyo hapa chini na tutajibu anwani utakayotoa.`)
};

const th_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้องการอีเมลไหม? ใช้แบบฟอร์มด้านล่างแล้วเราจะตอบกลับไปยังที่อยู่ที่คุณให้ไว้`)
};

const bs_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferirate email? Koristite formular ispod i odgovorit ćemo na adresu koju unesete.`)
};

const ja_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールをご希望ですか？下記フォームからご連絡いただければ、ご入力のアドレスに返信いたします。`)
};

const ko_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일이 편하신가요? 아래 양식을 작성해 주시면 입력하신 주소로 답장드립니다.`)
};

const pt_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefere o e-mail? Use o formulário abaixo e responderemos ao endereço que você fornecer.`)
};

const it_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferisci l’email? Usa il modulo qui sotto e ti risponderemo all’indirizzo che indichi.`)
};

const sv_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Föredrar du e-post? Använd formuläret nedan så svarar vi på den adress du anger.`)
};

const nl_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liever e-mail? Gebruik het onderstaande formulier en wij antwoorden op het adres dat je opgeeft.`)
};

const da_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foretrækker du e-mail? Brug formularen nedenfor, så svarer vi på den adresse, du angiver.`)
};

const nb_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foretrekker du e-post? Bruk skjemaet nedenfor, og vi vil svare på adressen du oppgir.`)
};

const fi_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pidätkö sähköpostista? Käytä alla olevaa lomaketta ja vastaamme antamaasi osoitteeseen.`)
};

const pl_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferujesz e-mail? Użyj poniższego formularza, a odpowiemy na podany adres.`)
};

const ru_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предпочитаете электронную почту? Используйте форму ниже, и мы ответим на адрес, который вы предоставляете.`)
};

const tr_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-postayı mı tercih edersiniz? Aşağıdaki formu kullanın, verdiğiniz adrese yanıt vereceğiz.`)
};

const hi_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल पसंद है? नीचे दिए गए फ़ॉर्म का उपयोग करें, हम आपके दिए गए पते पर जवाब देंगे।`)
};

const id_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebih suka email? Gunakan formulir di bawah ini dan kami akan membalas ke alamat yang Anda berikan.`)
};

const ms_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebih suka e-mel? Gunakan borang di bawah dan kami akan membalas ke alamat yang anda berikan.`)
};

const cs_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferujete e-mail? Použijte níže uvedený formulář a my odpovíme na adresu, kterou poskytnete.`)
};

const el_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Προτιμάτε email; Χρησιμοποιήστε την παρακάτω φόρμα και θα απαντήσουμε στη διεύθυνση που μας δίνετε.`)
};

const he_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מעדיפים דואר אלקטרוני? השתמשו בטופס למטה ונשיב לכתובת שתמסרו.`)
};

const af_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkies jy e-pos? Gebruik die vorm hieronder en ons sal antwoord na die adres wat jy verskaf.`)
};

const hu_contact_form_hint = /** @type {(inputs: Contact_Form_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inkább e-mailt? Használja az alábbi űrlapot, és válaszolunk a megadott címre.`)
};

/**
* | output |
* | --- |
* | "Prefer email? Use the form below and we will reply to the address you provide." |
*
* @param {Contact_Form_HintInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_form_hint = /** @type {((inputs?: Contact_Form_HintInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_HintInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_form_hint(inputs)
	if (locale === "de") return de_contact_form_hint(inputs)
	if (locale === "zh") return zh_contact_form_hint(inputs)
	if (locale === "ar") return ar_contact_form_hint(inputs)
	if (locale === "fr") return fr_contact_form_hint(inputs)
	if (locale === "vi") return vi_contact_form_hint(inputs)
	if (locale === "sw") return sw_contact_form_hint(inputs)
	if (locale === "th") return th_contact_form_hint(inputs)
	if (locale === "bs") return bs_contact_form_hint(inputs)
	if (locale === "ja") return ja_contact_form_hint(inputs)
	if (locale === "ko") return ko_contact_form_hint(inputs)
	if (locale === "pt") return pt_contact_form_hint(inputs)
	if (locale === "it") return it_contact_form_hint(inputs)
	if (locale === "sv") return sv_contact_form_hint(inputs)
	if (locale === "nl") return nl_contact_form_hint(inputs)
	if (locale === "da") return da_contact_form_hint(inputs)
	if (locale === "nb") return nb_contact_form_hint(inputs)
	if (locale === "fi") return fi_contact_form_hint(inputs)
	if (locale === "pl") return pl_contact_form_hint(inputs)
	if (locale === "ru") return ru_contact_form_hint(inputs)
	if (locale === "tr") return tr_contact_form_hint(inputs)
	if (locale === "hi") return hi_contact_form_hint(inputs)
	if (locale === "id") return id_contact_form_hint(inputs)
	if (locale === "ms") return ms_contact_form_hint(inputs)
	if (locale === "cs") return cs_contact_form_hint(inputs)
	if (locale === "el") return el_contact_form_hint(inputs)
	if (locale === "he") return he_contact_form_hint(inputs)
	if (locale === "af") return af_contact_form_hint(inputs)
	if (locale === "hu") return hu_contact_form_hint(inputs)
	return en_contact_form_hint(inputs)
});